import { Component, ojs, app } from "modular-openscriptjs";
import { either, monetary } from "../../helpers";
import { dc } from "../../declarations";

const h = app("h");

export default class OrderDetailDeliveryRequestView extends Component {
    render(order, ...args) {
        const req = order?.delivery_request;
        if (!req) return h.empty();

        const pickupLat = req.pickup_latitude;
        const pickupLng = req.pickup_longitude;
        const dropoffLat = req.dropoff_latitude;
        const dropoffLng = req.dropoff_longitude;

        const recipientName = req.recipient_name || "Recipient";
        const recipientNumber = req.recipient_number;
        const currency = order?.currency || dc.userCurrency || "KES";
        const deliveryFee = req.estimated_delivery_fee ?? 0;

        const pickupBranchName = req.pickup_branch?.name || "Pickup Location";

        return h.div(
            {
                class: "p-4 rounded-4 mb-3 shadow-sm bg-white",
                style: "max-width: 540px;",
            },
            h.div(
                { class: "d-flex flex-column gap-3" },

                // Title & Info
                h.div(
                    { class: "d-flex gap-3 align-items-start" },
                    h.div(
                        {
                            class: "bg-light rounded-3 d-flex align-items-center justify-content-center text-primary border flex-shrink-0",
                            style: "width: 70px; height: 70px;",
                        },
                        h.i({ class: "bi bi-truck fs-3" }),
                    ),
                    h.div(
                        { class: "flex-fill min-w-0" },
                        h.h5(
                            { class: "fw-bold text-dark mb-1 text-wrap" },
                            "Package Delivery"
                        ),
                        h.div(
                            { class: "d-flex flex-column gap-1 fs-sm text-muted" },
                            h.span(
                                "Delivery Fee: ",
                                h.strong(
                                    { class: "text-dark" },
                                    monetary(deliveryFee, currency)
                                )
                            ),
                            either(recipientName, () =>
                                h.span(
                                    "Recipient: ",
                                    h.strong({ class: "text-dark" }, recipientName)
                                )
                            )
                        )
                    )
                ),

                // Pickup location section
                h.div(
                    { class: "bg-light border rounded-3 p-3 w-100" },
                    h.div(
                        { class: "small text-muted text-uppercase fw-bold mb-2 d-flex align-items-center gap-1" },
                        h.i({ class: "bi bi-geo-alt-fill text-danger fs-5" }),
                        "Pickup Location"
                    ),
                    h.div(
                        { class: "d-flex justify-content-between align-items-center" },
                        h.div(
                            { class: "flex-fill min-w-0" },
                            h.span(
                                { class: "fw-bold text-dark d-block fs-sm" },
                                pickupBranchName
                            ),
                            either(
                                pickupLat && pickupLng,
                                () =>
                                    h.a(
                                        {
                                            href: `https://www.google.com/maps/search/?api=1&query=${pickupLat},${pickupLng}`,
                                            target: "_blank",
                                            class: "text-primary text-decoration-none fs-xsm d-flex align-items-center gap-1 mt-1",
                                        },
                                        h.i({ class: "bi bi-map" }),
                                        "Open Pickup in Google Maps"
                                    )
                            )
                        )
                    )
                ),

                // Dropoff location section
                h.div(
                    { class: "bg-light border rounded-3 p-3 w-100" },
                    h.div(
                        { class: "small text-muted text-uppercase fw-bold mb-2 d-flex align-items-center gap-1" },
                        h.i({ class: "bi bi-geo-fill text-success fs-5" }),
                        "Dropoff Location"
                    ),
                    h.div(
                        { class: "d-flex justify-content-between align-items-center" },
                        h.div(
                            { class: "flex-fill min-w-0" },
                            h.span(
                                { class: "fw-bold text-dark d-block fs-sm" },
                                "Recipient Location"
                            ),
                            either(
                                dropoffLat && dropoffLng,
                                () =>
                                    h.a(
                                        {
                                            href: `https://www.google.com/maps/search/?api=1&query=${dropoffLat},${dropoffLng}`,
                                            target: "_blank",
                                            class: "text-primary text-decoration-none fs-xsm d-flex align-items-center gap-1 mt-1",
                                        },
                                        h.i({ class: "bi bi-map" }),
                                        "Open Dropoff in Google Maps"
                                    )
                            )
                        ),
                        either(recipientNumber, () =>
                            h.a(
                                {
                                    href: `tel:${recipientNumber}`,
                                    class: "btn btn-outline-success btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0 flex-shrink-0 ms-2",
                                    style: "width: 32px; height: 32px;",
                                },
                                h.i({ class: "bi bi-telephone-fill" }),
                            )
                        )
                    )
                ),

                // Directions section
                either(
                    pickupLat && pickupLng && dropoffLat && dropoffLng,
                    () =>
                        h.a(
                            {
                                href: `https://www.google.com/maps/dir/?api=1&origin=${pickupLat},${pickupLng}&destination=${dropoffLat},${dropoffLng}`,
                                target: "_blank",
                                class: "text-primary text-decoration-none fs-sm fw-bold d-flex align-items-center justify-content-center gap-2 mt-2 p-2 border border-primary-subtle rounded-3 bg-primary-subtle bg-opacity-25 w-100",
                            },
                            h.i({ class: "bi bi-signpost-split-fill" }),
                            "See Directions (Pickup to Dropoff)"
                        )
                )
            ),
            ...args
        );
    }
}

ojs(OrderDetailDeliveryRequestView);
